import Backdrop from '@ixigo/iui/Backdrop';
import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { ReactNode, useEffect, useState } from 'react';
import { ToastProps } from './index.types';

function Toast({
    heading,
    visible,
    button,
    iconLeft,
    iconRight,
    onBackdropClick,
    subHeading,
    variant = 'error',
}: ToastProps) {
    const bgClass = {
        error: 'bg-red-500',
        success: 'bg-green-800',
    }[variant];

    const [isVisible, setVisible] = useState(visible);
    const [backdrop, setBackdrop] = useState(visible);

    const hide = () => {
        setBackdrop(false);

        const toast = document.getElementById('toast');
        if (!toast) return;

        toast.style.top = `-${toast.clientHeight + 10}px`;
        setTimeout(() => {
            toast.classList.remove('transition-[top]');
            setVisible(false);
        }, 300);
    };

    useEffect(() => {
        if (!backdrop) return;

        const toast = document.getElementById('toast');
        if (!toast) return;

        toast.classList.add('transition-[top]');
        toast.style.top = '20px';
    }, [backdrop]);

    useEffect(() => {
        const toast = document.getElementById('toast');
        if (!toast) return;

        toast.style.top = `-${toast.clientHeight + 10}px`;
        setBackdrop(true);
    }, [isVisible]);

    useEffect(() => {
        if (visible) {
            setVisible(true);
            return;
        }
        hide();
    }, [visible]);

    if (!isVisible) return null;

    return (
        <>
            <Backdrop open={backdrop} className='z-[999999]' onClick={onBackdropClick} />
            <div
                id='toast'
                className={clsx(
                    'fixed right-20 left-20 flex items-center gap-10 px-15 py-10 text-neutral rounded-10 z-[999999]',
                    bgClass,
                )}
                style={{ top: '-250px' }}
            >
                {iconLeft && <div className='flex w-20 h-20'>{iconLeft}</div>}
                <div className='flex flex-col justify-center items-start grow'>
                    <Typography variant='body-xs'>{heading}</Typography>
                    {subHeading && <Typography variant='body-2xs'>{subHeading}</Typography>}
                </div>
                {button as ReactNode}
                {iconRight && <div className='w-20 h-20'>{iconRight}</div>}
            </div>
        </>
    );
}

export default Toast;
